/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from "react";
import {  useLocation, useNavigate } from "react-router-dom";
import { Route, RouteProps, Routes } from "react-router-dom";
import { verifyToken } from "utils/validation";
import ProtectedRoute from "./ProtectedRoute";
import { AdyenRoutesName } from "./route-names";
import { getRoutePath, getRoutePermission } from "./route-utils";

export const PrivateRoute = ({ element, children, path }: RouteProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;

  useEffect(() => {
    const checkToken = async () => {
      const verify = await verifyToken();
      if (!verify) {
        navigate(getRoutePath(AdyenRoutesName.LOGIN));
      }
      const marketplaceId = localStorage.getItem("marketplaceId");
      if (marketplaceId) {
        navigate({
          pathname: getRoutePath(AdyenRoutesName.MARKETPLACE_CONTROL),
        });
      }
    };
    checkToken();
  }, [pathname]);

  const protectedRoutes = useMemo(
    () =>
      [
        AdyenRoutesName.EDIT_MARKETPLACE,
        AdyenRoutesName.MARKETPLACE_LOGS,
        AdyenRoutesName.DASHBOARD_LOGS,
        AdyenRoutesName.DASHBOARD_REPORTS,
      ].flatMap((route) => {
        return {
          path: getRoutePath(route),
          permission: getRoutePermission(route),
        };
      }),
    []
  );

  const checkRouteProtection = protectedRoutes.find(
    (route) => route.path === pathname
  );

  if (checkRouteProtection) {
    return (
      <ProtectedRoute
        permission={checkRouteProtection.permission!}
        element={element}
        path={path}
      >
        {children}
      </ProtectedRoute>
    );
  }

  return (
    <Routes>
      <Route path={path} element={element}>
        {children}
      </Route>
    </Routes>
  );
};
